import angular from 'angular'
import loglist from './loglist'
import {
    operation
} from 'redevConfig'

const list = (operation && operation.list) || ''
const loglistCtrl = list ? require(`redevelopment/system/operation/${list.controllerName}`) : require('./loglistCtrl')
const logListPage = list ? require(`redevelopment/system/operation/${list.templateName}`) : require('./views/logList.html')

function config($stateProvider) {
    $stateProvider
        .state('system.log.operation', {
            url: '/operation',
            template: '<div ui-view></div>',
            title: '操作日志',
            abstract: true,
            default: 'system.log.operation.list',
            // controller: 'loglist',
        })
        .state('system.log.operation.list', {
            url: '/list',
            controller: 'loglistCtrl',
            template: logListPage,
        })
}
export default angular
    .module('system.log.operation', [])
    .config(['$stateProvider', config])
    .controller('loglistCtrl', loglistCtrl.default)
    .controller('loglist', loglist)
    .name



// WEBPACK FOOTER //
// ./src/app/system/log/operation/index.js